import { Form, Row } from "antd";
import PlamoApiWithSaveNotifications from "../../../util/with-save-notification";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import FormItem from "../../../form/form-item";
import { AdvancedForm } from "../../../form/advanced-form";
import { useGetLocationQuery } from "../../../../../api/plamo-api";

const { useCreateLocationWithSaveNotificationMutation, useUpdateLocationWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;

function LocationDetails() {
  const { id } = useParams();
  const idInt = parseInt(id || "")
  const { data: location } = useGetLocationQuery({ id: idInt }, { skip: id === 'new' }) as { data: any }
  const [createLocation, { isLoading: isCreatingLocation }] = useCreateLocationWithSaveNotificationMutation()
  const [updateLocation, { isLoading: isUpdatingLocation }] = useUpdateLocationWithSaveNotificationMutation()
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const isLoading = isCreatingLocation || isUpdatingLocation;

  const onFinish = useCallback(async (values: any) => {
    if(id === 'new') {
      const { data: newLocation }:any = await createLocation(values);
      navigate(`./../${newLocation.id}`, { replace: true })
    } else {
      const newLocation = {...location, ...values}
      await updateLocation(newLocation);
    }
  }, [id, createLocation, updateLocation, navigate, location]);

  return (
    <>
    <AdvancedForm form={form} name="location" onFinish={onFinish} isLoading={isLoading} originalValues={location} initialEditing={id === 'new'}>
    <Row><h3>Basisdaten</h3></Row>
    <Row gutter={24}>
      <FormItem fieldName="name" label="Name" />
    </Row>
    <Row><h3>Adresse</h3></Row>
    <Row gutter={24}>
      <FormItem fieldName="address" label="Postadresse" type="text" />
      <FormItem fieldName="emailAddress" label="E-Mail-Adresse" />
    </Row>
    <Row><h3>Briefbogen</h3></Row>
    <Row gutter={24}>
      <FormItem fieldName="footerLeft" label="Footer links" type="text" />
      <FormItem fieldName="footerCenter" label="Footer Mitte" type="text" />
      <FormItem fieldName="footerRight" label="Footer rechts" type="text" />
    </Row>
  </AdvancedForm>
  </>)
}

export default LocationDetails;